import { QASection, QASectionNode } from 'interfaces/qa';
import { forEach, result, isEmpty } from 'libraries/lodash'
import { Flavour } from 'types/Flavour';
import { AppDispatch, RootState } from 'redux/store';
import {

  SET_QA_SECTION_ID,
  SET_QA_ROOT_SECTIONS,
  SET_QA_SECTIONS_MAP,
  SET_QA_SECTIONS,
  SET_QA_PICKED_SECTION,
  SET_QA_NODE_MAP,
  SET_QA_COMMENT_MAP
} from './types'

export const setQASectionId = (sectionId: string) => ({
  type: SET_QA_SECTION_ID,
  sectionId
})

export const setQAPickedSection = (flavour: Flavour, sections: Record<Flavour, QASectionNode>) => {
  return (dispatch: AppDispatch, _: any) => {
    if (!isEmpty(sections) && flavour) {
      const pickedSection = sections[flavour]
      dispatch({
        type: SET_QA_PICKED_SECTION,
        pickedSection
      })

      const nodeMap = new Map()
      Object.entries(pickedSection.nodes).forEach(([id, value]) => nodeMap.set(id, value))
      dispatch(setQANodeMap(nodeMap))
    }
  }
}

const setQANodeMap = (nodeMap: Map<string, QASection>) => ({
  type: SET_QA_NODE_MAP,
  nodeMap
})

export const setQARootSections = (pickedSection: QASectionNode) => {
  return (dispatch: AppDispatch, _: any) => {
    if (pickedSection && pickedSection.nodes) {
      const rootSections = result(
        pickedSection,
        ['nodes', pickedSection.root, 'childSections'],
        []
      ).map(id => ({
        ...pickedSection.nodes[id],
        empty: pickedSection.nodes[id].childSections.length <= 0
      }))

      dispatch({
        type: SET_QA_ROOT_SECTIONS,
        rootSections
      })
    }
  }
}

const setQaSectionsMap = (sections: Record<Flavour, QASectionNode>) => {
  return (dispatch: AppDispatch, _:any) => {
    const qaSectionsMap:Map<string, QASection> = new Map()

    Object.entries(sections).forEach(([flavour, { nodes }]) => {
      const entries:[string, QASection][] = Object.entries(nodes);
      entries.shift()
      entries.forEach(([sectionId, { id, ...fields }]) => {
        qaSectionsMap.set(sectionId, { flavour, ...fields })
      })
    })

    dispatch({
      type: SET_QA_SECTIONS_MAP,
      sectionsMap: qaSectionsMap
    })
  }
}

export const setQASections = (sections: Record<Flavour, QASectionNode>) => {
  return (dispatch:AppDispatch) => {
    if (typeof sections === 'object') {
      dispatch({
        type: SET_QA_SECTIONS,
        sections
      })
      dispatch(setQaSectionsMap(sections) as any)
    }
  }
}

export const setQACommentMap = (data: any) => {
  return (dispatch: AppDispatch, getState: () => RootState) => {
    const { qa: { commentMap: _commentMap } } = getState()
    const commentMap = new Map(_commentMap)

    forEach(data, ({ bookmarkId, answer }) => {
      return answer && !commentMap.has(bookmarkId) && commentMap.set(bookmarkId, { answer })
    })

    dispatch({
      type: SET_QA_COMMENT_MAP,
      commentMap
    })
  }
}
